"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePutBrandingSettingsMutation = exports.useUploadBrandingImageMutation = exports.useGetEmailPreviewQuery = exports.useGetBrandingSettingsByTeamIdQuery = exports.useGetEmailTypesQuery = exports.emailBranding = exports.EmailBrandingTagType = void 0;

var _queryString = require("query-string");

var _EmptyAppApi = require("../EmptyAppApi");

var EmailBrandingTagType;
exports.EmailBrandingTagType = EmailBrandingTagType;

(function (EmailBrandingTagType) {
  EmailBrandingTagType["Preview"] = "EmailBrandingTagType_Preview";
  EmailBrandingTagType["Settings"] = "EmailBrandingTagType_Settings";
})(EmailBrandingTagType || (exports.EmailBrandingTagType = EmailBrandingTagType = {}));

var emailBranding = _EmptyAppApi.emptyAppApi.injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      getEmailTypes: build.query({
        query: function query() {
          return '/api/v1/email-branding/email-types';
        }
      }),
      getBrandingSettingsByTeamId: build.query({
        query: function query(teamId) {
          return "/api/v1/email-branding/teams/".concat(teamId);
        },
        transformResponse: function transformResponse(response) {
          return response.data;
        }
      }),
      getEmailPreview: build.query({
        query: function query(_ref) {
          var teamId = _ref.teamId,
              params = _ref.params;
          return "/api/v1/email-branding/teams/".concat(teamId, "/preview?").concat((0, _queryString.stringify)(params));
        },
        transformResponse: function transformResponse(response) {
          return response.data;
        }
      }),
      uploadBrandingImage: build.mutation({
        query: function query(_ref2) {
          var file = _ref2.file;
          var formData = new FormData();
          formData.append('data', file, file.name);
          return {
            url: '/api/v1/email-branding/logo',
            method: 'POST',
            body: formData
          };
        },
        transformResponse: function transformResponse(response) {
          return response.data;
        }
      }),
      putBrandingSettings: build.mutation({
        query: function query(_ref3) {
          var teamId = _ref3.teamId,
              settings = _ref3.settings;
          return {
            url: "/api/v1/email-branding/teams/".concat(teamId),
            method: 'PUT',
            body: settings
          };
        },
        transformResponse: function transformResponse(response) {
          return response.data;
        }
      })
    };
  }
});

exports.emailBranding = emailBranding;
var useGetEmailTypesQuery = emailBranding.useGetEmailTypesQuery,
    useGetBrandingSettingsByTeamIdQuery = emailBranding.useGetBrandingSettingsByTeamIdQuery,
    useGetEmailPreviewQuery = emailBranding.useGetEmailPreviewQuery,
    useUploadBrandingImageMutation = emailBranding.useUploadBrandingImageMutation,
    usePutBrandingSettingsMutation = emailBranding.usePutBrandingSettingsMutation;
exports.usePutBrandingSettingsMutation = usePutBrandingSettingsMutation;
exports.useUploadBrandingImageMutation = useUploadBrandingImageMutation;
exports.useGetEmailPreviewQuery = useGetEmailPreviewQuery;
exports.useGetBrandingSettingsByTeamIdQuery = useGetBrandingSettingsByTeamIdQuery;
exports.useGetEmailTypesQuery = useGetEmailTypesQuery;